import { render } from "./_From.vue?vue&type=template&id=32cdb55b"
import script from "./_From.vue?vue&type=script&lang=js"
export * from "./_From.vue?vue&type=script&lang=js"

import "./_From.vue?vue&type=style&index=0&id=32cdb55b&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__